import { datadogRum } from "@datadog/browser-rum";

/**
 * Real User Monitoring (performance, errors).
 * Disabled when the Datadog env variables are not set (e.g. local development).
 *
 * @see https://docs.datadoghq.com/real_user_monitoring/browser/
 */
export const initDatadogRum = () => {
  const applicationId = process.env.GATSBY_DATADOG_APPLICATION_ID;
  const clientToken = process.env.GATSBY_DATADOG_CLIENT_TOKEN;

  if (!applicationId || !clientToken) {
    return;
  }

  datadogRum.init({
    applicationId,
    clientToken,
    site: "datadoghq.eu",
    service: "shine-fr",
    env: process.env.GATSBY_DEPLOY_ENV,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    trackUserInteractions: false,
    trackResources: true,
    trackLongTasks: true,
    trackAnonymousUser: false,
    sessionPersistence: "memory",
  });
};
